import React from 'react';

import usePDPProductLabel from 'data-hooks/usePDPProductLabel';
import PDPGalleryLabelsUI from './PDPGalleryLabelsUI';

const PDPGalleryLabels = () => {
  const {
    loading,
    error,
    data: { productLabel },
  } = usePDPProductLabel();

  if (error) return null;

  return (
    <PDPGalleryLabelsUI
      loading={loading}
      labels={productLabel ? [productLabel] : []}
    />
  );
};

export default PDPGalleryLabels;
